import { render, staticRenderFns } from "./yAxios.vue?vue&type=template&id=1dabd85d&"
import script from "./yAxios.vue?vue&type=script&lang=js&"
export * from "./yAxios.vue?vue&type=script&lang=js&"
import style0 from "./yAxios.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports